import { Component, HostListener, OnInit } from "@angular/core";
import SwiperCore, {
  Autoplay,
  Navigation,
  Pagination,
  SwiperOptions,
} from "swiper";
import Swiper from "swiper";
import { ISocialMediaLinks } from "src/app/Models/Interface/SocialMediaLinks/social-media-links";
import { SocialMediaLinksService } from "src/app/Services/SocialMediaLinkService/social-media-links.service";
import { UserDetailsService } from "../../../../Components/Services/user-details.service";
import { SDContact } from "../../../../Models/StaticData/contact";

Swiper.use([Navigation, Pagination, Autoplay]);

@Component({
  selector: "app-about-us",
  templateUrl: "./about-us.component.html",
  styleUrls: ["./about-us.component.scss"],
})
export class AboutUsComponent implements OnInit {
  scrolled = 0;
  initialScroll = 0;

  teamData = [
    {
      id: "1",
      name: "Karim Hasab El-Nabi",
      position: "Founder",
    },
    {
      id: "2",
      name: "Osama Al-Arabi",
      position: "Co-Founder/Support Director",
    },
    {
      id: "3",
      name: "Diana Didoronkute",
      position: "Account Manager",
    },
    {
      id: "4",
      name: "Ahmed Gawdat",
      position: "Chief Accountant",
     },
    // {
    //   id: "5",
    //   name: "Mohamed AboElezz",
    //   position: "Growth Product Manager",
    // },
    {
      id: "6",
      name: "Passant Hussein",
      position: "Teachnical Lead",
    },
    {
      id: "9",
      name: "Muhammed Jaamour",
      position: "Accountant",
    },
    {
      id: "10",
      name: "Wajih Ahmad Safieh",
      position: "Order fulfillment associate",
    },
    {
      id: "12",
      name: "Shameem Moideen",
      position: "Logistics Officer",
    },
    {
      id: "14",
      name: "Mohamed Arshad",
      position: "Order fulfillment associate",
    },
    {
      id: "16",
      name: "Emine Memedovska",
      position: "Marketplace Catalogue Specialist",
    },
  ];

  @HostListener("window:scroll", ["$event"])
  onWindowScroll() {
    const numb = window.scrollY;
    if (numb >= 100) {
      this.scrolled = 1;
      this.initialScroll = 1;
    } else {
      this.scrolled = 0;
    }
    if (this.scrolled == 1) {
      document.querySelector(".oct-svg")?.classList.add("hero-poly");
      document
        .querySelector(".hero-title")
        ?.classList.add("hero-title-animate");
    } else {
      document.querySelector(".oct-svg")?.classList.remove("hero-poly");

      document
        .querySelector(".hero-title")
        ?.classList.remove("hero-title-animate");
    }
    if (this.initialScroll == 1) {
      document.querySelector(".oct-svg")?.classList.add("hero-animate-back");
      document
        .querySelector(".hero-title")
        ?.classList.add("hero-title-animate-back");
    }
  }
  allies: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 20,
    breakpoints: {
      "581": {
        slidesPerView: 2,
        spaceBetween: 20,
      },

      "1024": {
        slidesPerView: 3,
        spaceBetween: 65,
      },
      "1366": {
        slidesPerView: 5,
        spaceBetween: 150,
      },
    },
    centeredSlides: true,
    loop: true,
    autoplay: { delay: 0 },
    speed: 2000,
    // navigation: {
    //   nextEl: ".feedback-swiper-button-next",
    //   prevEl: ".feedback-swiper-button-prev",
    // },
    // pagination: {
    //   el: ".feedback-swiper-pagination",
    //   type: "bullets",
    //   clickable: true,
    // },
  };
  team: SwiperOptions = {
    slidesPerView: 2,
    spaceBetween: 27,
    breakpoints: {
      "581": {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      "800": {
        slidesPerView: 2.5,
        spaceBetween: 27,
      },
      // "900": {
      //   slidesPerView: 2,
      //   spaceBetween: 27,
      // },
    },
    centeredSlides: true,
    loop: true,
    autoplay: { delay: 0 },
    speed: 2000,
  };
  year = new Date().getFullYear();
  socialMediaLinks: ISocialMediaLinks[] = [];
  contact = SDContact;

  constructor(
    private socialMediaLinksService: SocialMediaLinksService,
    public userDetailsService: UserDetailsService
  ) {}

  ngOnInit(): void {
    this.getSocialMediaLinks();
  }

  getSocialMediaLinks(): void {
    this.socialMediaLinksService.getSocialMediaLinks().subscribe((res) => {
      this.socialMediaLinks = res;
    });
  }
}
